module.exports = __webpack_public_path__ + "media/images/icon__arrow-right-c90a0a729b7f0fb10573498b0b5cc3e5.png";